import React from "react";
import { Stack, Typography, Chip } from "@mui/material";
import { LoginOutlined } from "@mui/icons-material";
import { shortUserAgent } from "../deviceSignals";

const METHOD_LABEL = { assertion: "Sign-in", attestation: "Enrollment" };

function fmt(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString();
  } catch (e) {
    return iso;
  }
}

/** Compact login-history list, shared by the user and admin views. */
export default function LoginHistoryList({ items, emptyText = "No login history yet." }) {
  if (!items || items.length === 0) {
    return <Typography sx={{ fontSize: 13, color: "var(--text-2)" }}>{emptyText}</Typography>;
  }
  return (
    <Stack gap={1}>
      {items.map((h, i) => (
        <Stack
          key={`${h.credential_id}-${h.logged_in_at}-${i}`}
          direction="row"
          alignItems="center"
          gap={1.5}
          sx={{
            p: 1.25,
            borderRadius: "10px",
            backgroundColor: "var(--surface-2)",
            border: "1px solid var(--border-1)",
          }}
        >
          <LoginOutlined sx={{ fontSize: 18, color: "var(--text-2)" }} />
          <Stack sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: "var(--text-1)" }} noWrap>
                {h.credential_label || "Unknown device"}
              </Typography>
              <Chip
                size="small"
                label={METHOD_LABEL[h.login_method] || h.login_method}
                sx={{ height: 18, fontSize: 10 }}
              />
            </Stack>
            <Typography
              sx={{ fontSize: 11, color: "var(--text-2)" }}
              noWrap
              title={h.user_agent || undefined}
            >
              {h.device_type ? `${h.device_type} · ` : ""}
              {h.ip ? `${h.ip} · ` : ""}
              {h.user_agent ? `${shortUserAgent(h.user_agent)} · ` : ""}
              {h.device_fingerprint ? `FP ${String(h.device_fingerprint).slice(0, 8)} · ` : ""}
              {fmt(h.logged_in_at)}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
